import PropTypes from "prop-types";
import ErrorInput from "../ui/ErrorInput";

export const InputFecha = ({ label, id, formik, labelStyle, labelClassName, inputStyle }) => {
  const formatLabel = (txt) => {
    if (typeof txt !== "string") return txt;
    if (txt.includes("*")) {
      const parts = txt.split("*");
      return (
        <>
          {parts[0]} <span className="text-danger fw-bold">*</span>
          {parts.slice(1).join("*")}
        </>
      );
    }
    return txt;
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <label
          htmlFor={id}
          className={labelClassName || "form-label fw-bold mb-0"}
          style={{ ...labelStyle, marginBottom: 0 }}
        >
          {formatLabel(label)}
        </label>
        {formik.errors[id] !== undefined && formik.touched[id] !== undefined && (
          <ErrorInput touched={formik.touched[id]} error={formik.errors[id]} />
        )}
      </div>

      <input
        type="date"
        name={id}
        id={id}
        className="form-control"
        style={{
          boxShadow: "none",
          borderColor: "#cccccc",
          height: "38px",
          backgroundColor: "#ffffff",
          ...inputStyle,
        }}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[id] || ""}
      />
    </div>
  );
};

InputFecha.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
  labelStyle: PropTypes.object,
  labelClassName: PropTypes.string,
  inputStyle: PropTypes.object,
};
